import styled from "styled-components";

export const WeatherMapWrapper = styled.div`
  width: 60%;

  @media (max-width: 768px) {
    width: 100%;
    height: 50vh;
  }
`;
